import { computed } from 'vue'
import type { Application, ApplicationStatus } from '@/types'
import type { ApplicationsState } from './state'

export const createGetters = (state: ApplicationsState) => {
  const filteredApplications = computed(() => {
    let result = [...state.applications]

    if (state.filters.search) {
      const search = state.filters.search.toLowerCase()
      result = result.filter(
        (app) =>
          app.name.toLowerCase().includes(search) ||
          app.description?.toLowerCase().includes(search)
      )
    }

    if (state.filters.projectId) {
      result = result.filter((app) => app.projectId === state.filters.projectId)
    }

    if (state.filters.status) {
      result = result.filter((app) => app.status === state.filters.status)
    }

    if (state.filters.platform) {
      result = result.filter((app) => app.platform === state.filters.platform)
    }

    return result
  })

  const applicationsByProject = computed(() => {
    const grouped: Record<string, Application[]> = {}
    filteredApplications.value.forEach((app) => {
      if (!grouped[app.projectId]) {
        grouped[app.projectId] = []
      }
      grouped[app.projectId].push(app)
    })
    return grouped
  })

  const applicationsByStatus = computed(() => {
    const grouped: Record<ApplicationStatus, Application[]> = {
      planning: [],
      in_development: [],
      staging: [],
      production: [],
      deprecated: [],
      retired: [],
    }
    state.applications.forEach((app) => {
      if (grouped[app.status]) {
        grouped[app.status].push(app)
      }
    })
    return grouped
  })

  const getApplicationsByProjectId = (projectId: string) =>
    computed(() => state.applications.filter((a) => a.projectId === projectId))

  return {
    filteredApplications,
    applicationsByProject,
    applicationsByStatus,
    getApplicationsByProjectId,
  }
}
